import React, { useState, Component, setUser, useEffect,useContext } from "react";
import BookingFormView from "./General/BookingFormView";
import Tile from "../Tile/Tile";
import Button from "../Button/Button";
import cx from "classnames";
import scrollTo from "../../utils/scrollTo";
import UserContext from "../../store/UserContext";
import { Link, useHistory } from "react-router-dom";
import { getToken } from "../../utils/common"

var newArrayData = [];
var seePriceArray = [];
var allCategories = [];
var arr = [];
// var selectedCabin={};
class GuestSelectionView extends Component {
  render() {
    const { values } = this.props;
    return (
      <>
        {/* <div className="grid grid-cols-3 border-b p-6">
                    <div>

                    </div>
                    <div className="text-center text-basecolor font-bold">Title of cruise trip</div>
                </div> */}
        <BookingClass nextStep={this.props} />
      </>
    );
  }
}
export default GuestSelectionView;

const BookingClass = ({ nextStep }) => {
  var selectedCabin={};
  let history = useHistory();
  const [user, setUser] = React.useContext(UserContext);
  const booking = user.booking || {};

  var getCab;
useEffect(()=>{
   getCab = JSON.parse(sessionStorage.getItem('getCabins'));
},[])
 

  // TODO change me:
  const maxRooms = nextStep.maxRoom;
  const [rooms, setRooms] = useState(JSON.parse(sessionStorage.getItem('getCabins')) ? JSON.parse(sessionStorage.getItem('getCabins')) : booking.rooms || [createRoom(0)]);
  const maxRoomsReached = rooms.length >= maxRooms;
  const [currentRoom, setCurrentRoom] = useState([]);
  const [renderView, setRenderView] = useState(false);
  const [callApi, setCallApi] = useState(0);
  const [allData, setAllData] = useState([]);
  const [cabins, setCabins] = useState([]);
  const [addCabinEnabled, setAddCabinEnabled] = useState(true);
  const [lastModifiedRoom, setLastModifiedRoom] = useState([]);
  const [priceData, setPriceData] = useState([]);
  const [allCabin, setAllcabin] = useState({});


useEffect(() => {
    setRenderView(true);
  }, []);
useEffect(()=>{
  setCabins(rooms)
// setRooms(allrooms)
},[selectedCabin,])

allCategories.push(rooms)

  const changeRooms = (room) =>
    setRooms(
      rooms.map((r) => (r.id === room.id ? Object.assign({}, r, room) : r))
    );

  const removeRoom = (id) => {
    Object.keys(selectedCabin).forEach(selected => {
      if (!rooms.some(room => room.selected === selected)) {
          delete selectedCabin[selected];
      }
  });
    setRooms(
      rooms
        .filter((r) => r.id !== id)
        .map((r, i) => Object.assign({}, r, { id: i }))
    );
  };

var allrooms = JSON.parse(sessionStorage.getItem('allRooms'));
var prices = JSON.parse(sessionStorage.getItem('priceData'));


  const handleSubmit = (e) => {
    
    // setCallApi(1)
    rooms.map((room) => {
      if (lastModifiedRoom.includes(room.id)) {
        room.selected = null;
        room.room_id = null;
        room.room_number = null;
        room.total_price = null;
      }
    });
    setUser(
      Object.assign({}, user, {
        booking: Object.assign({}, booking, { rooms }),
      })
    );
    e.preventDefault();
    var newroom;
    if(currentRoom.length === 0){
      newroom = cabins[cabins.length - 1];
    }else{
      newroom = currentRoom
    }
//start call api 
var currancyStatus = JSON.parse(sessionStorage.getItem('currency'));
var fare = JSON.parse(localStorage.getItem('specialFare'));

const { adults, infants, children,selected,selectedData } = newroom;
let roomss = [{ adults: adults, infants: infants, children: children,selected:selected,selectedData:selectedData }];


  const dataWithContent = arr.filter(item => Object.keys(item).length > 0);
  let lastObjectt =  dataWithContent.length ? dataWithContent[dataWithContent.length - 1] : null;

  selectedCabin = { ...lastObjectt, ...selectedCabin };

  cabins?.forEach(room => {
    let selected = room.selected;
    if (selected) {
        if (selectedCabin[selected]) {
            selectedCabin[selected]++;
        } else {
            selectedCabin[selected] = 1;
        }
    }
  
  });
  
  let newSelected = newroom.selected;
  if (newSelected) {
    if (selectedCabin[newSelected]) {
        selectedCabin[newSelected]++;
    } else {
        selectedCabin[newSelected] = 1;
    }
  }


 if (!seePriceArray.includes(newroom.id)) {
            fetch(
         process.env.REACT_APP_API_ENDPOINT +
         "/agent_portal/itineraries/" +
         user?.booking?.itinerary?.id +
         "/check_availability",
         {
             method: "POST",
             headers: {
                 Accept: "application/json",
                 "Content-Type": "application/json",
                 Authorization: `Bearer ${getToken()}`,
             },
             body: JSON.stringify({
                 currency: currancyStatus.code,
                 visitorID: user?.booking.visitorID,
                 itineraryID: user?.booking?.itinerary?.id,
                 promoCode: "", // TODO: connect landing page promo codes here
                 selected: selectedCabin,
                 hold_booking: false,
                 rooms: roomss.map((room) => {
                     const { adults, infants, children } = room;
                     return {
                         adults,
                         infants,
                         children,
                     };
                 }),
                 price_type: fare ? 'special_pricing' : null
             }),
         }
     )
     .then((res) => {
         if (res.ok) {
             return res.json();
         } else {
             throw new Error("Something went wrong");
         }
     })
     .then((response) => {
     
        //  setPricingData(response?.data?.checkAvailability[0]?.categories);
    
       setCallApi(0)  
     })
     .catch((error) => {
         // Handle error
     });
    }

// end call api 
    // const getLastObjectWithData = () => {
    //         const dataWithContent = selectedCabin.filter(item => Object.keys(item).length > 0);
    //         return dataWithContent.length ? dataWithContent[dataWithContent.length - 1] : null;
    //       };
    //       const lastObject = getLastObjectWithData();
    

    // const filteredCategories = prices?.data?.checkAvailability[0]?.categories.filter(category => selectedCabin.hasOwnProperty(category.category_id));
    
    const categ = cabins.map(item => {
      const { selectedData } = item;
      return selectedData 
    })

    var mainArr = [];
    categ?.forEach(element => {
      mainArr.push({ "categories": [element] });
});
sessionStorage.setItem('selectedData', JSON.stringify(mainArr));
    nextStep.nextStep();
  };
  
  return (
    <>
      {renderView && (
        <>
          <BookingFormView
            title="Please add cabins and guests"
            id="room-form"
            lessSpace={true}
            selectedCabin={selectedCabin}
            // nextStep={nextStep.nextStep()}
            onClick={handleSubmit}
            disabled={addCabinEnabled}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {rooms.map((room,index) => (
                <RoomView
                  index={index}
                  setAddCabinEnabled={setAddCabinEnabled}
                  key={room.id}
                  selectedCabin={selectedCabin}
                  setAllcabin={setAllcabin}
                  setAllData={setAllData}
                  allData={allData}
                  allCabin={allCabin}
                  setCurrentRoom={setCurrentRoom}
                  room={room}
                  callApi={callApi}
                  setPriceData={setPriceData}
                  priceData={priceData}
                  setCallApi={setCallApi}
                  rooms={rooms}
                  visitorID={booking.visitorID}
                  onChange={changeRooms}
                  onRemove={room.id > 0 ? () => removeRoom(room.id) : null}
                  id={`room-${room.id}`}
                  setLastModifiedRoom={setLastModifiedRoom}
                />
              ))}
              <div
                className={cx(
                  "rounded-lg flex flex-col",
                  "text-black bg-white",
                  "shadow-xl",
                  "pb-14"
                )}
              >
                <div className="bg-j-orange w-full -bottom-0 text-white p-4 mb-10 rounded-lg">
                  <p className="text-j-magenta font-medium text-base">
                    Exclusive offers for your booking:
                  </p>
                  <ul
                    class="list-inside bg-rose-200 text-base ml-4 mt-4 text-white"
                    style={{ listStyle: "inside" }}
                  >
                    <li className="text-white">
                      Free sailing for kids upto 12 years of age, across
                      stateroom categories*
                    </li>
                    <li className="text-white">
                      Indulge in a wide range of beverages and mixers at no extra charge for adults (21+).
                    </li>
                  </ul>
                  {/* <p className="text-white font-medium text-base mt-4 mb-4">
                    The offers are valid on all bookings made until 30th
                    september 2024.
                  </p> */}
                  <a className="text-sm text-white italic ">
                    Terms & Conditions apply*{" "}
                  </a>
                </div>
                <Tile.Inner
                  style={{
                    alignSelf: "center",
                    justifyContent: "center",
                    padding: "0",
                    margin: "0",
                  }}
                >
                  {!maxRoomsReached && (
                    <Button
                      className="bg-j-orange text-white w-full pt-1"
                      disabled={addCabinEnabled}
                      onClick={() => {
                      
                          setRooms([
                          ...rooms.map((r) =>
                            Object.assign({}, r, { open: false })
                          ),
                          createRoom(rooms.length),
                        ]);
                        scrollTo(`room-${rooms.length}`);
                      
                      }}
                    >
                      Add another cabin
                    </Button>
                  )}
                  {maxRoomsReached && (
                    <p className="font-medium text-base px-5 pb-4 mt-4 mb-4 italic text-center">
                      For bookings more than {nextStep.maxRoom} cabins, please
                      contact our customer support team via email or call.
                      info@cordeliacruises.com / 02268811111
                    </p>
                  )}
                </Tile.Inner>
              </div>
              {/* <Tile className="mb-8 rounded-lg" shadow style={{alignItems:'center', justifyContent: 'center', minHeight: '300px', padding: '0'}}>
                    <div className="bg-j-orange w-full -bottom-0 text-white p-4">
                           <p>Book now to get benefits on May - July 2021 sailings:</p>
                           <ul class="list-inside bg-rose-200" style={{listStyle:'inside'}}>
                               <li>Kids sail free*</li>
                               <li>Book with just 25%*</li>
                               <li>Free rescheduling until 7 days prior to sailing*</li>
                           </ul>
                           <p>A perfect holiday getaway for your guests!</p>
                           <a>Terms and conditions apply* </a>
                        </div>
                        <Tile.Inner style={{alignSelf:'center', justifyContent: 'center',padding: '0', margin: '0'}}>
                        {!maxRoomsReached && (
                        <Button
                            className="bg-j-orange text-white w-full pt-1"
                            onClick={() => {
                                setRooms([
                                ...rooms.map((r) => Object.assign({}, r, { open: false })),
                                createRoom(rooms.length),
                                ]);
                                scrollTo(`room-${rooms.length}`);
                            }}
                        >
                            Add another room
                        </Button>
                        )}
                        </Tile.Inner>
                    </Tile> */}
            </div>
          </BookingFormView>
        </>
      )}
    </>
  );
};
  
const RoomView = ({
  room,
  rooms,
  index,
  selectedCabin,
  onChange,
  setAllcabin,
  setCurrentRoom,
  allCabin,
  setAddCabinEnabled,
  onRemove,
  setCallApi,
  callApi,
  allData,
  setDisabled,
  setPriceData,
  setAllData,
  visitorID,
  setLastModifiedRoom,
  ...rest
}) => {

  const [user, setUser] = useContext(UserContext)
  const [isVisible, setIsVisible] = useState(room.selected ? true : false);
  const [cabin, setCabin] = useState({});
  const [seePricing, setSeePricing] = useState();
  const [pricingData, setPricingData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedCabinss, setselectedCabinss] = useState({});
  
useEffect(()=>{
  setCabin(rooms)
 let lastRoom = rooms[rooms.length - 1];
let isButtonDisabled = !lastRoom.selected;
sessionStorage.setItem('allRooms', JSON.stringify(rooms));
if(isButtonDisabled){
  setAddCabinEnabled(true)
}else{
  setAddCabinEnabled(false)
}
if(callApi){
  setSelectedCategory();
  handlePrices();
}
},[isVisible,setAddCabinEnabled,rooms,callApi])


const handlePrices = () => {
  setIsVisible(true);

  const newRoom = Object.assign({}, room, seePricing);
  var currancyStatus = JSON.parse(sessionStorage.getItem('currency'));
  var fare = JSON.parse(localStorage.getItem('specialFare'));
 
  const { adults, infants, children,selected } = room;
     rooms = [{ adults: adults, infants: infants, children: children,selected:selected }];
     
     setSelectedCategory();
     localStorage.setItem('selected', JSON.stringify(selectedCabin));
     let selectedCabinData =  JSON.parse(localStorage.getItem('selected'));
     let selectedData;
     if (selectedCabin && Object.keys(selectedCabin).length !== 0) {
       selectedData = selectedCabin;
     } else {
       selectedData = selectedCabinData;
     }
     arr.push(selectedCabin);
      if (!seePriceArray.includes(room.id)) {
                 fetch(
              process.env.REACT_APP_API_ENDPOINT +
              "/agent_portal/itineraries/" +
              user?.booking?.itinerary?.id +
              "/check_availability",
              {
                  method: "POST",
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${getToken()}`,
                  },
                  body: JSON.stringify({
                      currency: currancyStatus.code,
                      visitorID: user?.booking.visitorID,
                      itineraryID: user?.booking?.itinerary?.id,
                      promoCode: "", // TODO: connect landing page promo codes here
                      selected: selectedData,
                      hold_booking: false,
                      rooms: rooms.map((room) => {
                          const { adults, infants, children } = room;
                          return {
                              adults,
                              infants,
                              children,
                          };
                      }),
                      price_type: fare ? 'special_pricing' : null
                  }),
              }
          )
          .then((res) => {
              if (res.ok) {
                  return res.json();
              } else {
                  throw new Error("Something went wrong");
              }
          })
          .then((response) => {
              const newState = {...response};
              const categories = newState.data.checkAvailability[0].categories;
              const allCategories = [];
              categories.forEach(category => {
                  allCategories.push(category);
                  if (category.sub_category && category.sub_category.length > 0) {
                      category.sub_category.forEach(subCat => {
                          allCategories.push(subCat);
                      });
                  }
              });
              setPriceData(newState)
              sessionStorage.setItem('priceData', JSON.stringify(newState));
              newState.data.checkAvailability[0].categories = allCategories;
              const uniqueDataArray = response?.data?.checkAvailability[0]?.categories.filter((item, index, self) =>
                index === self.findIndex((t) => t.category_id === item.category_id)
              );
              setPricingData(response?.data?.checkAvailability[0]?.categories);
         
            setCallApi(0)  
          })
          .catch((error) => {
              // Handle error
          });
      }
};

  const isFull = room.adults + room.children + room.infants >= room.max;

  const roomHeader = (
    <div className="flex justify-between">
      <h4 className="text-j-magenta uppercase self-center cursor-pointer">
        Cabin {room.id + 1}
      </h4>
      {onRemove && (
        <p
          className="leading-none text-xs text-j-orange pt-2 cursor-pointer text-xl"
          onClick={onRemove}
        >
          Remove
        </p>
      )}
    </div>
  );

  const updateRoom = (data) => {
    setSeePricing(data)
    setIsVisible(false);
    const newRoom = Object.assign({}, room, data);
    if (!newArrayData.includes(room.id)) {
      newArrayData.push(room.id);
    } else {
      // newArrayData.splice(newArrayData.indexOf(room.id), 1);
    }
    //newArrayData.push(room.id)
    setLastModifiedRoom(newArrayData);
    onChange(newRoom);
  };
  
  useEffect(()=>{
    if(room.selected){
      setIsVisible(true)
    }
  },[])


  const handleRadioChange = (id,index,alldata) => {
    setSelectedIndex(index);
    const data = { selected: id,selectedData:alldata,index:index}
    const newRoom = Object.assign({}, room, data);
    if (!newArrayData.includes(room.id)) {
      newArrayData.push(room.id);
    }   
    setLastModifiedRoom(newArrayData);
    onChange(newRoom);
      setSelectedCategory();
      setCurrentRoom(newRoom)
      localStorage.setItem('selected', JSON.stringify(selectedCabin));  
};

const setSelectedCategory = ()=>{
    cabin?.forEach(room => {
    let selected = room.selected;
    if (selected) {
        if (selectedCabin[selected]) {
            selectedCabin[selected]++;
        } else {
            selectedCabin[selected] = 1;
        }
    }
  
  });
  
  let newSelected = room.selected;
  if (newSelected) {
    if (selectedCabin[newSelected]) {
        selectedCabin[newSelected]++;
    } else {
        selectedCabin[newSelected] = 1;
    }
  }  
}
useEffect(() => {
  if (room.selected) {
    setIsVisible(false);
  }
}, [room.selected]);

let getData = [];
var allrooms = JSON.parse(sessionStorage.getItem('getCabins'));
allrooms?.forEach(element => {
    getData.push(element)
});

const getSelectedCategory = ()=>{
  if(pricingData.length > 0){
    
    return(  
      pricingData.map((data, index) => {
      if (room.index === index) {
        return (
          <div key={index} className="px-4 py-4 ">
            <div className="flex flex-wrap items-end justify-between px-3">
              <div className="flex flex-wrap gap-4 items-center mt-4">
                <p className="text-md font-bold">{data.name}</p>
              </div>
              <div className="flex flex-wrap gap-2 items-center">
                <p className="text-xs font-bold">Sub-Total</p>-
                <div>
       {data?.price?.discount > 0 ? (
          <p className="text-sm font-medium line-through group-hover:text-blue-500">
          ₹ {(Math.floor(data?.price?.actual_total) || 0).toLocaleString("hi-IN")}
          </p>
        ) :    <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹ {(Math.floor(data?.price?.total) || 0).toLocaleString("hi-IN")}
    </p>}
    {data?.price?.discount > 0 ? <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹{(Math.floor(data?.price?.total) || 0).toLocaleString("hi-IN")}
    </p> : null }
       </div>
               
              </div>
            </div>
          </div>
        );
      } else {
        return null;
      }
    })
    )
  
  }else if(getData){
  
    return(  
      rooms.map((data, index) => {
      if (room.id === data.id && data.selectedData) {
        return (
          <div key={index} className="px-4 py-4">
            <div className="flex flex-wrap items-end justify-between px-3">
              <div className="flex flex-wrap gap-4 items-center mt-4">
                <p className="text-md font-bold">{data.selectedData.name}</p>
              </div>
              <div className="flex flex-wrap gap-2 items-center">
                <p className="text-xs font-bold">Sub-Total</p>-
                <div>
       {data?.selectedData?.price?.discount > 0 ? (
          <p className="text-sm font-medium line-through group-hover:text-blue-500">
          ₹ {(Math.floor(data?.selectedData?.price?.actual_total) || 0).toLocaleString("hi-IN")}
          </p>
        ) :    <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹{(Math.floor(data?.selectedData?.price?.total) || 0).toLocaleString("hi-IN")}
    </p>}
    {data?.selectedData?.price?.discount > 0 ? <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹{(Math.floor(data?.selectedData?.price?.total) || 0).toLocaleString("hi-IN")}
    </p> : null }
       </div>  
              </div>
            </div>
          </div>
        );
      } else {
        return null;
      }
    })
    )
  }
}
var allrooms = JSON.parse(sessionStorage.getItem('getCabins'));


  return (
    <Tile className="rounded-lg" {...rest} shadow>
      <Tile.Top>
        {cabin.length - 1 === index ? roomHeader : null}
        <p className="text-j-gray flex pt-4 pb-4 text-sm">
          <i className="fas fa-bed pr-4 pt-1" />
          Cabins can accommodate 2, 3 or 4 guests
        </p>
        <WidgetView
          min={1}
          value={room.adults}
          disabled={isFull}
          icon="fas fa-restroom"
          title="Adults"
          description="12 & above"
          onChange={(value) => updateRoom({ adults: value,index:'',selectedData:'',selected:''})}
        />
        <WidgetView
          value={room.children}
          disabled={isFull}
          icon="fas fa-child"
          title="Children"
          description="2 years - 12 years"
          onChange={(value) => updateRoom({ children: value,index:'',selectedData:'',selected:'' })}
        />
        <WidgetView
          value={room.infants}
          disabled={isFull}
          icon="fas fa-baby"
          title="Infants"
          description="12 months - 2 years"
          onChange={(value) => updateRoom({ infants: value,index:'',selectedData:'',selected:''})}
        />
      </Tile.Top>
      <p className="text-j-magenta flex pl-4 pt-2 pb-4 text-sm">
        *Infants below 12 months are not allowed to travel
      </p>
      <>
      <div className="">
      {/* cabin.length - 1 === index ? */}
     {
     room.selected ? 
     cabin.length - 1 === index ?  <Button
        onClick={handlePrices}
        className={"text-j-orange hover:text-white text-md w-18 self-center mx-4 mb-4 border border-j-orange"}
      >
       { 'Change'}
      </Button> : null
      : 
      <Button
        onClick={handlePrices}
        className={"text-white text-md w-18 self-center mx-4 mb-4 bg-j-orange"}
 
      >
       {'* See Prices'}
      </Button> }
      </div>
    
      { isVisible ? 

        pricingData?.map((data, index) => (
  <div
    key={data.id}
    className="px-4 py-4 shadow-md cursor-pointer bg-white hover:bg-gray-200 group"
    onClick={() => handleRadioChange(data.category_id, index, data)}
  >
    <div className="flex flex-wrap items-end justify-between px-3">
      <div className="flex flex-wrap gap-4 items-center mt-4">
        <input
          type="radio"
          className="h-4 w-4"
          name={`room-selection${room.id}`}
          value={room.selected}
          onChange={(e) => {
            e.stopPropagation(); // Prevent click event from outer div
            handleRadioChange(data.category_id, index, data);
          }}
          checked={room.index === index}
        />
        <p className="text-md font-bold group-hover:text-blue-500">{data.name}</p>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <p className="text-xs font-bold group-hover:text-blue-500">Sub-Total</p>-
       <div>
       {data?.price?.discount > 0 ? (
          <p className="text-sm font-medium line-through group-hover:text-blue-500">
          ₹ {(Math.floor(data?.price?.actual_total) || 0).toLocaleString("hi-IN")}
          </p>
        ) :    <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹{(Math.floor(data?.price?.total) || 0).toLocaleString("hi-IN")}
    </p>}
    {data?.price?.discount > 0 ? <p className="text-md font-bold flex flex-wrap items-end justify-end group-hover:text-blue-500">
      ₹{(Math.floor(data?.price?.total) || 0).toLocaleString("hi-IN")}
    </p> : null }
       </div>
      </div>
    </div>

  </div>
))
:null }
 {getSelectedCategory()}
      </>
    </Tile>
  );

};

const WidgetView = ({
  value,
  min = 0,
  icon,
  title,
  description,
  disabled,
  onChange,
}) => (
  <div className="flex justify-between mb-4">
    <Button
      className={cx(
        "text-white text-4xl w-12 self-center",
        value > min ? "bg-j-orange" : "bg-j-gray-lighter"
      )}
      smallPadding
      unbold
      disabled={value <= min}
      onClick={() => onChange(value - 1)}
    >
      -
    </Button>
    <div className="flex-grow self-center text-center">
      <div className="h-9">
        {value ? (
          <span className="text-3xl font-bold leading-none">{value}</span>
        ) : (
          <i className={cx(icon, "text-3xl text-j-gray-lighter")} />
        )}
      </div>
      <p className="leading-4 text-sm uppercase text-j-magenta">{title}</p>
      <p className="text-xs uppercase text-j-gray">{description}</p>
    </div>
    <Button
      className={cx(
        "text-white text-4xl w-12 self-center",
        disabled ? "bg-grey-600" : "bg-j-orange"
      )}
      smallPadding
      unbold
      disabled={disabled}
      onClick={() => onChange(value + 1)}
    >
      +
    </Button>
  </div>
);

const createRoom = (id) => ({
  id,
  adults: 1,
  children: 0,
  infants: 0,
  selected:'',
  selectedData:'',
  min: 1,
  max: 4,
  index:null,
  open: true,
});
